import { eachMinuteOfInterval, endOfDay, set, startOfDay } from "date-fns";
import React, { memo } from "react";

// eslint-disable-next-line react/display-name
const TimesBar = memo(({ times }) => {
    if (!times || times.length === 0) return null;

    const StartOfWeek = startOfDay(times[0]);
    const EndtOfWeek = endOfDay(times[0]);
    const startHour = set(StartOfWeek, { hours: 1 });
    const endHour = set(EndtOfWeek, { hours: 17, minutes: 45 });

    let hoursInDay = eachMinuteOfInterval(
        {
            start: startHour,
            end: endHour,
        },
        { step: 15 }
    );

    return (
        <div
            style={{
                width: "42px",
                display: "flex",
                justifyContent: "center",
                borderRadius: "6px",
                overflow: "hidden",
            }}
        >
            <div style={{ display: "flex", borderRadius: "6px", flexDirection: "column" }}>
                {hoursInDay.map((_, i) => (
                    <div
                        key={i}
                        style={{
                            height: "4px",
                            width: "42px",
                            backgroundColor: "#86efac", // équivalent bg-green-300
                        }}
                    />
                ))}
            </div>
        </div>
    );
});

export default TimesBar;
